module.exports = __webpack_public_path__ + "h5/img/wei.43cdea82.png";